import React, { useState, useEffect } from "react";
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateNumberCounterTabData,numberCounterTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [backgroundColor, setBackgroundColor] = useState(numberCounterTabData.background_color);
    const [widgetTitleColor, setWidgetTitleColor] = useState(numberCounterTabData.widget_title_color);
    const [widgetTitleSize, setWidgetTitleSize] = useState(numberCounterTabData.widget_title_size);
    const [widgetTitleSizeDropdownOpen, setWidgetTitleSizeDropdownOpen] = useState(false);

    const [counterBackgroundColor, setCounterBackgroundColor] = useState(numberCounterTabData.counter_background_color);
    const [numberColor, setNumberColor] = useState(numberCounterTabData.number_color);
    const [captionColor, setCaptionColor] = useState(numberCounterTabData.caption_color);
    const [iconBackgroundColor, setIconBackgroundColor] = useState(numberCounterTabData.icon_background_color);
    const [fontType, setFontType] = useState(numberCounterTabData.font_type);
    const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
    const [numberSize, setNumberSize] = useState(numberCounterTabData.number_size);
    const [numberSizeDropdownOpen, setNumberSizeDropdownOpen] = useState(false);
    const [captionSize, setCaptionSize] = useState(numberCounterTabData.caption_size);
    const [captionSizeDropdownOpen, setCaptionSizeDropdownOpen] = useState(false);
    const [iconFontSize, setIconFontSize] = useState(numberCounterTabData.icon_font_size);
    const [isEnableMobileSetting, setIsEnableMobileSetting] = useState(Number(numberCounterTabData.is_enable_mobile_setting));

    const [tabletNumberSize, setTabletNumberSize] = useState(numberCounterTabData.tablet_number_size);
    const [tabletNumberSizeDropdownOpen, setTabletNumberSizeDropdownOpen] = useState(false);
    const [tabletCaptionSize, setTabletCaptionSize] = useState(numberCounterTabData.tablet_caption_size);
    const [tabletCaptionSizeDropdownOpen, setTabletCaptionSizeDropdownOpen] = useState(false);
    const [tabletIconFontSize, setTabletIconFontSize] = useState(numberCounterTabData.tablet_icon_font_size);

    const [phoneNumberSize, setPhoneNumberSize] = useState(numberCounterTabData.phone_number_size);
    const [phoneNumberSizeDropdownOpen, setPhoneNumberSizeDropdownOpen] = useState(false);
    const [phoneCaptionSize, setPhoneCaptionSize] = useState(numberCounterTabData.phone_caption_size);
    const [phoneCaptionSizeDropdownOpen, setPhoneCaptionSizeDropdownOpen] = useState(false);
    const [phoneIconFontSize, setPhoneIconFontSize] = useState(numberCounterTabData.phone_icon_font_size);

    const [styleTabCustomCss, setStyleTabCustomCss] = useState(numberCounterTabData.custom_css);

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateNumberCounterTabData("background_color", color.hex);
    };

    // Handlers Widget Title Color Change
    const handleWidgetTitleColorChange = (color) => {
        setWidgetTitleColor(color.hex);
        updateNumberCounterTabData("widget_title_color", color.hex);
    };

    // Handlers Widget Title Size Change
    const handleWidgetTitleSizeChange = (font) => {
        setWidgetTitleSize(font);
        updateNumberCounterTabData("widget_title_size", font);
        setWidgetTitleSizeDropdownOpen(false);
    };


    // Handlers Counter Background Color Change
    const handleCounterBackgroundColorChange = (color) => {
        setCounterBackgroundColor(color.hex);
        updateNumberCounterTabData("counter_background_color", color.hex);
    };

    // Handlers Number Color Change
    const handleNumberColorChange = (color) => {
        setNumberColor(color.hex);
        updateNumberCounterTabData("number_color", color.hex);
    };

    // Handlers Caption Color Change
    const handleCaptionColorChange = (color) => {
        setCaptionColor(color.hex);
        updateNumberCounterTabData("caption_color", color.hex);
    };

    // Handlers Icon Background Color Change
    const handleIconBackgroundColorChange = (color) => {
        setIconBackgroundColor(color.hex);
        updateNumberCounterTabData("icon_background_color", color.hex);
    };

    // Handlers Font Type Change
    const handleFontChange = (font) => {
        setFontType(font);
        updateNumberCounterTabData("font_type", font);
        setFontDropdownOpen(false);
    };

    // Handlers Number  Size Type Change
    const handleNumberSizeChange = (font) => {
        setNumberSize(font);
        updateNumberCounterTabData("number_size", font);
        setNumberSizeDropdownOpen(false);
    };

    // Handlers Caption  Size Type Change
    const handleCaptionSizeChange = (font) => {
        setCaptionSize(font);
        updateNumberCounterTabData("caption_size", font);
        setCaptionSizeDropdownOpen(false);
    };

    // Handlers Icon Font Size Change
    const handleIconFontSizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        // Define min and max constants for clarity
        const MIN_SIZE = 40;
        const MAX_SIZE = 100;
        // Clamp the value within the range
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setIconFontSize(valueWithPx);
        updateNumberCounterTabData("icon_font_size", valueWithPx);
    };
    

    //Handlers Enable Mobile Setting Change
    const handleEnableMobileSettingChange = (e) => {
        const checked = e.target.checked;
        setIsEnableMobileSetting(checked);
        updateNumberCounterTabData("is_enable_mobile_setting", checked); 
    };

    // Handlers Tablet Number  Size Type Change
    const handleTabletNumberSizeChange = (font) => {
        setTabletNumberSize(font);
        updateNumberCounterTabData("tablet_number_size", font);
        setTabletNumberSizeDropdownOpen(false);
    };

    // Handlers Tablet Caption  Size Type Change
    const handleTabletCaptionSizeChange = (font) => {
        setTabletCaptionSize(font);
        updateNumberCounterTabData("tablet_caption_size", font);
        setTabletCaptionSizeDropdownOpen(false);
    };

    // Handlers Tablet Icon Font Size Change
    const handleTabletIconFontSizeChange = (e) => {
        const value = `${e.target.value}px`;
        setTabletIconFontSize(value);
        updateNumberCounterTabData("tablet_icon_font_size", value);
    }; 

    // Handlers Phone Number  Size Type Change
    const handlePhoneNumberSizeChange = (font) => {
        setPhoneNumberSize(font);
        updateNumberCounterTabData("phone_number_size", font);
        setPhoneNumberSizeDropdownOpen(false);
    };

    // Handlers Phone Caption  Size Type Change
    const handlePhoneCaptionSizeChange = (font) => {
        setPhoneCaptionSize(font);
        updateNumberCounterTabData("phone_caption_size", font);
        setPhoneCaptionSizeDropdownOpen(false);
    };

    // Handlers Phone Icon Font Size Change
    const handlePhoneIconFontSizeChange = (e) => {
        const value = `${e.target.value}px`;
        setPhoneIconFontSize(value);
        updateNumberCounterTabData("phone_icon_font_size", value);
    }; 

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateNumberCounterTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Widget Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={backgroundColor} setColor={setBackgroundColor}  onChangeComplete={handleBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Widget Title Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={widgetTitleColor} setColor={setWidgetTitleColor}  onChangeComplete={handleWidgetTitleColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Widget Title Font</span>
                            <div className="color-pikr-box" onClick={() => setWidgetTitleSizeDropdownOpen(!widgetTitleSizeDropdownOpen)}>
                                <em>{widgetTitleSize}</em>
                                {widgetTitleSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleWidgetTitleSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Counter Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={counterBackgroundColor} setColor={setCounterBackgroundColor}  onChangeComplete={handleCounterBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Number Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={numberColor} setColor={setNumberColor}  onChangeComplete={handleNumberColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Caption Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={captionColor} setColor={setCaptionColor} onChangeComplete={handleCaptionColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Icon Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={iconBackgroundColor} setColor={setIconBackgroundColor}  onChangeComplete={handleIconBackgroundColorChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box" onClick={() => setFontDropdownOpen(!fontDropdownOpen)}>
                                <em>{fontType}</em>
                                {fontDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Default"].map((font) => (
                                            <li key={font} onClick={() => handleFontChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Number Font</span>
                            <div className="color-pikr-box" onClick={() => setNumberSizeDropdownOpen(!numberSizeDropdownOpen)}>
                                <em>{numberSize}</em>
                                {numberSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleNumberSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Caption Font</span>
                            <div className="color-pikr-box" onClick={() => setCaptionSizeDropdownOpen(!captionSizeDropdownOpen)}>
                                <em>{captionSize}</em>
                                {captionSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleCaptionSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Icon Size</span>
                            <em>{iconFontSize}</em>
                            <div className="slider-container">
                                <input type="range" min="50px" max="100px" value={parseInt(iconFontSize)} onChange={handleIconFontSizeChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("mobile_settings")}>Mobile Settings<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "mobile_settings" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Fonts on Mobile</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Enable Mobile Settings</span>
                                <div className="form-group">
                                    <input id="open_is_enable_mobile_setting" className="chkbx-toggle" type="checkbox" checked={isEnableMobileSetting} onChange={handleEnableMobileSettingChange} />
                                    <label for="open_is_enable_mobile_setting"></label>
                                </div>
                            </div>
                        </div>
                        {Number(numberCounterTabData.is_enable_mobile_setting) === 1 && (
                            <>
                            <span>Tablet</span>
                            <div className="side-baar-box-header">                                
                                {/* Number Font Size Selector */}
                                <div className="box-header-row">
                                    <span>Number Font</span>
                                    <div className="color-pikr-box" onClick={() => setTabletNumberSizeDropdownOpen(!tabletNumberSizeDropdownOpen)}>
                                        <em>{tabletNumberSize}</em>
                                        {tabletNumberSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px","18px", "19px", "20px", "22px", "24px", "26px", "28px","30px", "34px", "36px", "40px", "44px", "48px", "50px"
                                                ].map((font) => (
                                                    <li key={font} onClick={() => handleTabletNumberSizeChange(font)}>
                                                        {font}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                {/* Caption Font Size Selector */}
                                <div className="box-header-row">
                                    <span>Caption Font</span>
                                    <div className="color-pikr-box" onClick={() => setTabletCaptionSizeDropdownOpen(!tabletCaptionSizeDropdownOpen)}>
                                        <em>{tabletCaptionSize}</em>
                                        {tabletCaptionSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px","18px", "19px", "20px", "22px", "24px", "26px", "28px","30px", "34px", "36px", "40px", "44px", "48px", "50px"
                                                ].map((font) => (
                                                    <li key={font} onClick={() => handleTabletCaptionSizeChange(font)}>
                                                        {font}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                {/* Icon Size Slider */}
                                <div className="box-header-row">
                                    <span>Icon Size</span>
                                    <em>{tabletIconFontSize}</em>
                                    <div className="slider-container">
                                        <input
                                            type="range"
                                            min="12"
                                            max="100"
                                            value={parseInt(tabletIconFontSize)}
                                            onChange={handleTabletIconFontSizeChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <span>Phone</span>
                            <div className="side-baar-box-header">                                
                                {/* Number Font Size Selector */}
                                <div className="box-header-row">
                                    <span>Number Font</span>
                                    <div className="color-pikr-box" onClick={() => setPhoneNumberSizeDropdownOpen(!phoneNumberSizeDropdownOpen)}>
                                        <em>{phoneNumberSize}</em>
                                        {phoneNumberSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px","18px", "19px", "20px", "22px", "24px", "26px", "28px","30px", "34px", "36px", "40px", "44px", "48px", "50px"
                                                ].map((font) => (
                                                    <li key={font} onClick={() => handlePhoneNumberSizeChange(font)}>
                                                        {font}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                {/* Caption Font Size Selector */}
                                <div className="box-header-row">
                                    <span>Caption Font</span>
                                    <div className="color-pikr-box" onClick={() => setPhoneCaptionSizeDropdownOpen(!phoneCaptionSizeDropdownOpen)}>
                                        <em>{phoneCaptionSize}</em>
                                        {phoneCaptionSizeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px","18px", "19px", "20px", "22px", "24px", "26px", "28px","30px", "34px", "36px", "40px", "44px", "48px", "50px"
                                                ].map((font) => (
                                                    <li key={font} onClick={() => handlePhoneCaptionSizeChange(font)}>
                                                        {font}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                {/* Icon Size Slider */}
                                <div className="box-header-row">
                                    <span>Icon Size</span>
                                    <em>{phoneIconFontSize}</em>
                                    <div className="slider-container">
                                        <input
                                            type="range"
                                            min="12"
                                            max="100"
                                            value={parseInt(phoneIconFontSize)}
                                            onChange={handlePhoneIconFontSizeChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            </>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 
        </div>
    );
};

export default StyleTab;